export const COMPANY = {
  name: "Dharma Composite Private Limited",
  short: "Dharma Composite",
  email: "admin@dharmacomposite.com",
  phone: "+91 82956 34906",
  phoneRaw: "+918295634906",
  address: "Bhiwadi, Rajasthan 301019, India",
};

export const CONTACTS = [
  {
    name: "Nitin Choudhary",
    phone: "+91 98128 81699",
    phoneRaw: "+919812881699",
    email: null,
  },
  {
    name: "Mohit Choudhary",
    phone: "+91 82956 34906",
    phoneRaw: "+918295634906",
    email: "mohit@dharmacomposite.com",
  },
];

export const PRODUCTS = [
  {
    id: "frp-process-equipment",
    num: "01",
    name: "FRP Process Equipment",
    tag: "Multi-Material Builds",
    desc: "Custom process equipment and piping systems in GRP/GRE, PP-FRP, HDPE-FRP, PVDF, PVC and PPH — including equipment for effluent, sewage and water treatment plants, PP/FRP ducting, motor panels and canopy covers.",
    image: "/images/real_piping.jpg",
  },
  {
    id: "chemical-storage-tanks",
    num: "02",
    name: "Chemical Storage Tanks",
    tag: "PP · PPH · HDPE · ECTFE",
    desc: "Corrosion-proof storage for aggressive media — sulphuric acid tanks, polypropylene and PP-FRP tanks, pickling tanks, electroplating tanks and STP tanks, built in PP, PPH, HDPE or ECTFE-lined FRP to match your chemistry.",
    image: "/images/real_chemtank.jpg",
  },
  {
    id: "frp-tanks",
    num: "03",
    name: "FRP Tanks",
    tag: "1 KL – 100 KL",
    desc: "The workhorse range — PP-FRP tanks, underground water tanks, horizontal and rectangular tanks, Rhino water tanks and agitator tanks, filament-wound or hand-laid for decades of leak-proof service.",
    image: "/images/real_tank.jpg",
  },
  {
    id: "frp-pipes",
    num: "04",
    name: "FRP Pipes",
    tag: "Pressure & Gravity",
    desc: "FRP and PP-FRP piping and ducting pipe for process lines, effluent transfer and corrosive exhaust — smooth bore, lightweight, and jointed to your site layout.",
    image: "/images/real_pipes.jpg",
  },
  {
    id: "frp-reactors",
    num: "05",
    name: "FRP Reactors",
    tag: "Agitator Ready",
    desc: "FRP and PP-FRP reaction vessels with provision for agitators, coils and nozzles — corrosion-resistant alternatives to stainless reactors for acidic and alkaline process duty.",
    image: "/images/gen_reactor.jpg",
  },
  {
    id: "frp-lining",
    num: "06",
    name: "FRP Lining",
    tag: "On-Site & Shop",
    desc: "Chemical-resistant FRP lining for MS tanks, concrete sumps, floors and drains — extends the life of existing structures handling acids, alkalis and effluents.",
    image: "/images/gen_lining.jpg",
  },
  {
    id: "frp-blowers",
    num: "07",
    name: "FRP Blowers",
    tag: "Corrosive Exhaust Duty",
    desc: "Industrial and centrifugal blowers in FRP and PP-FRP with dynamically balanced impellers — rated for continuous duty in acidic and alkaline exhaust streams. Low noise, high efficiency.",
    image: "/images/real_blower.jpg",
  },
  {
    id: "air-pollution-control",
    num: "08",
    name: "Air Pollution Control Systems",
    tag: "CPCB Compliance",
    desc: "PP-FRP scrubbers, wet scrubbers, venturi scrubbers and complete industrial scrubber systems for acid fumes, chlorine and process gases — designed to meet emission norms at minimal pressure drop.",
    image: "/images/real_scrubber.jpg",
  },
  {
    id: "fume-exhaust",
    num: "09",
    name: "Fume Exhaust Systems",
    tag: "Turnkey Extraction",
    desc: "End-to-end fume handling — hoods, ducting, blowers, scrubbers and stacks — fabricated in FRP as one integrated, leak-tight system for pickling, plating and chemical process lines.",
    image: "/images/gen_fume.jpg",
  },
  {
    id: "frp-coating",
    num: "10",
    name: "FRP Coating",
    tag: "Surface Protection",
    desc: "Chemical-resistant FRP coating systems for floors, tanks and structural steel — a seamless barrier against splash, spillage and corrosive plant atmospheres.",
    image: "/images/gen_coating.jpg",
  },
  {
    id: "frp-hoppers",
    num: "11",
    name: "FRP Hoppers",
    tag: "Custom Geometry",
    desc: "Moulded FRP hoppers and silo cones for powder, granule and slurry handling — smooth internal finishes for clean discharge, made to your outlet size and cone angle.",
    image: "/images/gen_hopper.jpg",
  },
  {
    id: "frp-fume-hoods",
    num: "12",
    name: "FRP Fume Hoods",
    tag: "Source Capture",
    desc: "Aerodynamically profiled fume hoods and canopies that capture fumes at the source — corrosion-proof, lightweight and easy to retrofit over existing process lines.",
    image: "/images/gen_hood.jpg",
  },
  {
    id: "frp-elbows",
    num: "13",
    name: "FRP Elbows",
    tag: "Any Angle · Any Dia",
    desc: "Moulded FRP elbows and bends in any angle and diameter, matched to your piping class — dimensionally consistent fittings for leak-tight FRP and PP-FRP lines.",
    image: "/images/real_fittings.jpg",
  },
];

export const SERVICES = [
  {
    id: "scaffolding",
    num: "01",
    name: "Scaffolding Services",
    tag: "Supply · Erection · Dismantling",
    desc: "Certified scaffolding solutions for plant construction, maintenance and shutdown jobs — supplied, erected and dismantled by trained crews with strict on-site safety compliance.",
    points: ["Cuplock & frame systems", "Trained erection crews", "Shutdown & maintenance support"],
    image: "/images/svc_scaffolding.jpg",
  },
  {
    id: "industrial-painting",
    num: "02",
    name: "Industrial Painting",
    tag: "Protective Coatings",
    desc: "Protective painting for steel structures, tanks, pipelines and plant equipment — proper surface preparation followed by primer and top-coat systems rated for harsh industrial atmospheres.",
    points: ["Surface preparation & blasting", "Structure, tank & pipeline coating", "High-build protective paint systems"],
    image: "/images/svc_painting.jpg",
  },
  {
    id: "industrial-epoxy",
    num: "03",
    name: "Industrial Epoxy Solutions",
    tag: "Flooring · Lining · Coating",
    desc: "Epoxy flooring, lining and coating systems for chemical plants, process areas and warehouses — seamless, chemical-resistant and easy to clean, applied over concrete or steel substrates.",
    points: ["Epoxy flooring & screeds", "Chemical-resistant linings", "Anti-skid & heavy-duty options"],
    image: "/images/svc_epoxy.jpg",
  },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];
